import { createPinia } from 'pinia'
import { VERSION as ACQUISIT_UI_VERSION } from '@Visma-Real-Estate-Solutions/acquisit-ui-vue/library'

const pinia = createPinia()

Object.defineProperty(window, '__ui', {
	value: ACQUISIT_UI_VERSION,
	writable: false
})

// Set up raygun
import { Raygun } from '@Visma-Real-Estate-Solutions/acquisit-ui-vue/library'

if (import.meta.env.ZAPDOS_CRM_RAYGUN_KEY) {
	Raygun.init(import.meta.env.ZAPDOS_CRM_RAYGUN_KEY, import.meta.env.BUILD, import.meta.env.DEV)
}

import '@Visma-Real-Estate-Solutions/acquisit-ui-vue/dist/style.css'
import { createApp, ref } from 'vue'
import App from './App.vue'

const app = createApp(App)

if (import.meta.env.ZAPDOS_CRM_RAYGUN_KEY) {
	app.config.errorHandler = (err, vm, info) => {
		Raygun.instance?.send(err as Error, ['vue'], {
			info
		})
	}
}

app.use(pinia)

// Set up AcquisitUI
import type { Frontend } from '@Visma-Real-Estate-Solutions/acquisit-ui-vue/library'
import { install } from '@Visma-Real-Estate-Solutions/acquisit-ui-vue/library'
import { loadSVG } from '@/lib/svg'

install({
	app,
	env: import.meta.env.DEV ? 'dev' : 'production',
	language: ref('nb'),
	loadSVG,
	
	frontend: ref<Frontend>({
		getRootContainer(): HTMLElement {
			return document.querySelector('#app') as HTMLElement
		},
		
		getRootFooter(): HTMLElement | undefined {
			return undefined
		},
		
		getRootHeader(): HTMLElement | undefined {
			return undefined
		},
	})
})

// Set up router
import router from './router'
app.use(router)

// Go!
app.mount('#app')
